"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USBanModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const jotai_1 = require("jotai");
const fix_body_1 = require("../../util/fix-body");
const atom_1 = require("../../atom");
const react_i18next_1 = require("react-i18next");
require("./style.scss");
const USBanModal = () => {
    const [open, setOpen] = (0, jotai_1.useAtom)(atom_1.$USPreBanState);
    const { isMobile, isBot } = (0, jotai_1.useAtomValue)(atom_1.$UserAgent);
    const { enterPageName } = (0, jotai_1.useAtomValue)(atom_1.$RootTraffic);
    const isFirstShow = (0, react_1.useRef)(true);
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        if (open && isMobile && isFirstShow.current) {
            isFirstShow.current = false;
            window.Tea('geoblock_web_page_alert_show', {
                pageName: enterPageName,
            });
            fix_body_1.FixBodyUtil.fix();
        }
        else {
            fix_body_1.FixBodyUtil.restore();
        }
    }, [open, isMobile]);
    const handleClick = (0, react_1.useCallback)(() => {
        setOpen(false);
        window.Tea('geoblock_web_page_alert_click', {
            pageName: enterPageName,
        });
    }, []);
    if (!isMobile || isBot) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('ban-modal-wrapper', { open, close: !open }), children: [(0, jsx_runtime_1.jsx)("div", { className: "ban-modal-mask" }), (0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('ban-modal'), children: [(0, jsx_runtime_1.jsxs)("div", { className: "ban-modal-content", children: [(0, jsx_runtime_1.jsx)("div", { className: "ban-modal-title", children: t('unNotice_modal_header') }), (0, jsx_runtime_1.jsxs)("div", { className: "ban-modal-text", children: [(0, jsx_runtime_1.jsx)("p", { children: t('unNotice_modal_body') }), (0, jsx_runtime_1.jsx)("a", { href: "https://newsroom.tiktok.com/en-us/tiktok-jan-19", children: t('unNotice_link_newsUpdate') })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "ban-modal-confirm-btn", onClick: handleClick, children: t('unNotice_modal_btn_dismiss') })] })] }));
};
exports.USBanModal = USBanModal;
